import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { getEnv } from '@btcdirect/shared/src/composables/util/meta';

interface ViteEnv extends ImportMetaEnv {
    NODE_ENV?: string;
    VITE_API_ENDPOINT?: string;
    VITE_API_KEY?: string;
    VITE_APP_URL?: string;
    VITE_DEFAULT_LOCALE?: string;
    VITE_ENV?: string;
    VITE_QUOTE_INTERVAL?: string;
    VITE_TYPING_DELAY?: string;
    VITE_APPLICATION_LOGGING_DSN?: string;
}

const env: ViteEnv = getEnv();

const { warn } = useLogger();

export const useEnv = () => {
    const getString = (key: string, fallback: string): string => {
        return get(key) ?? fallback;
    };

    const getNumber = (key: string, fallback: number): number => {
        const value = get(key);
        if (!value) {
            return fallback;
        }

        return parseInt(value) || fallback;
    };

    const getBoolean = (key: string, fallback: boolean): boolean => {
        const value = get(key);
        if (!value) {
            return fallback;
        }

        return value === 'true';
    };

    return {
        getString,
        getNumber,
        getBoolean
    };
};

const get = (key: string): string | null => {
    if (!(key in env)) {
        warn(`Environment variable with key ${key} could not be found`);
        return null;
    }

    if ('boolean' === typeof env[key]) {
        warn(`Environment variable with key ${key} is a boolean and should not be used`);
        return null;
    }

    return env[key] as string;
};
